
class Viewport {
    constructor() {
        this._window = window;
        this._onLoadTasks = [];
        this._onResizeTasks = [];

        this._innerHeight = null;
        this._innerWidth = null;
        this._outerHeight = null;
        this._outerWidth = null;

        this.init();
    }

    get innerHeight() {
        return new Promise((resolve, reject) => {
            try {
                if (this._innerHeight === null) {
                    requestAnimationFrame(() => {
                        this._innerHeight = this._window.innerHeight;
                        resolve(this._innerHeight);
                    });
                } else {
                    resolve(this._innerHeight);
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    get innerWidth() {
        return new Promise((resolve, reject) => {
            try {
                if (this._innerWidth === null) {
                    requestAnimationFrame(() => {
                        this._innerWidth = this._window.innerWidth;
                        resolve(this._innerWidth);
                    });
                } else {
                    resolve(this._innerWidth);
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    get outerHeight() {
        return new Promise((resolve, reject) => {
            try {
                if (this._outerHeight === null) {
                    requestAnimationFrame(() => {
                        this._outerHeight = this._window.outerHeight;
                        resolve(this._outerHeight);
                    });
                } else {
                    resolve(this._outerHeight);
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    get outerWidth() {
        return new Promise((resolve, reject) => {
            try {
                if (this._outerWidth === null) {
                    requestAnimationFrame(() => {
                        this._outerWidth = this._window.outerWidth;
                        resolve(this._outerWidth);
                    });
                } else {
                    resolve(this._outerWidth);
                }
            } catch (error) {
                reject(error);
            }
        });
    }

    get scrollX() {
        return new Promise((resolve, reject) => {
            try {
                requestAnimationFrame(() => {
                    resolve(this._window.scrollX);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    get scrollY() {
        return new Promise((resolve, reject) => {
            try {
                requestAnimationFrame(() => {
                    resolve(this._window.scrollY);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    /**
     * @returns {Boolean}
     */
    get isTouchScreen() {
        if (this._window.ontouchstart !== undefined) {
            return true;
        } else if (this._window.navigator.maxTouchPoints > 0) {
            return true;
        } else if (this._window.navigator.msMaxTouchPoints > 0) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * @returns {Boolean}
     */
    get isMobileDevice() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(this._window.navigator.userAgent)) {
            return true;
        }
        return false;
    }

    init() {
        this._onResizeTasks.push(() => {
            this._innerHeight = this._window.innerHeight;
            this._innerWidth = this._window.innerWidth;
            this._outerHeight = this._window.outerHeight;
            this._outerWidth = this._window.outerWidth;
        });

        this._window.addEventListener('load', () => {
            requestAnimationFrame(() => {
                let task;
                while (task = this._onLoadTasks.shift()) {
                    task();
                }
            });
        }, { passive: true, once: true });

        this._window.addEventListener('resize', () => {
            requestAnimationFrame(() => {
                this._onResizeTasks.forEach(task => task());
            });
        }, { passive: true });
    }

    /**
     * @param {Function} task
     */
    onLoad(task) {
        this._onLoadTasks.push(task);
    }

    /**
     * @param {Function} task
     */
    onResize(task) {
        this._onResizeTasks.push(task);
    }
}

export const viewport = new Viewport();
